<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @export="exportFile"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        :checked-count="checkedCount"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
        @exportFile="batchExportFile"
        @clearCheckboxRow="clearCheckboxRow"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: {
          codes: chooseTemplateOptions.codes,
        },
      }"
      @confirmClose="clearCheckboxRow"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import ChooseTemplate from '@/views/factory/components/choose-template'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, ChooseTemplate },
  data() {
    return { usePage: true,
      checkedRow: [],
      chooseTemplateOptions: {
        visible: false,
        codes: [],
        templateGroup: '',
      },
     }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .orderTechPricingListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    batchExportFile(templateGroup) {
      const codes = this.checkedRow
        .map((e) => e.orderTechPricingCode)
      console.log(codes)
      this.chooseTemplateOptions = {
        visible: true,
        codes,
        templateGroup,
      }
    },
    exportFile({ orderTechPricingCode }, { templateGroup }) {
      this.chooseTemplateOptions = {
        visible: true,
        codes: [orderTechPricingCode],
        templateGroup,
      }
    },
    clearCheckboxRow() {
      this.checkedRow = []
      this.$refs.main.clearCheckboxRow()
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'production-orderTechPricing-detail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
